import { Grid } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';

import ServiceExportButton from './ServiceExportButton';
import ServiceImportButton from './ServiceImportButton';
import ServicesTable from './ServicesTable';

const Height100 = styled.div`
  height: 100%;
`;

const Header = styled(Grid)`
  background-color: #efefef;
  padding: ${(props) => props.theme.spacing(2)}px!important;
`;

export default function ProductList() {
  return (
    <Grid container direction="column" wrap="nowrap" component={Height100}>
      <Grid item>
        <Header container spacing={2} justify="flex-end">
          <Grid item>
            <ServiceImportButton />
          </Grid>
          <Grid item>
            <ServiceExportButton />
          </Grid>
        </Header>
      </Grid>
      <Grid item xs>
        <ServicesTable></ServicesTable>
      </Grid>
    </Grid>
  );
}
